module.exports = __webpack_public_path__ + "eg.svg?0937143657d85d2f6342833231d48065";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/eg.svg
// module id = 991
// module chunks = 27